import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import FormSettings from '../../../shared/constants/form-settings';
import Notifications from '../../../shared/constants/notifications';

import SVGIcon from '../../../../../../common/react/components/svg-icon';
import DatePicker from 'react-datepicker';

import { coalesce, getUtcString } from '../../../shared/utilities';

import moment from 'moment';
import classNames from 'classnames';

export default class CloseDateSection extends Component {
	constructor (props) {
		super(props);

		// Manual binding is required by react-datepicker library!
		this.handleDateChange = this.handleDateChange.bind(this);
	}

	render () {
		const {
			localization,
			schedule,
			hasScheduleClosing,
			timeInterval,
			minDate
		} = this.props;

		let closeGroupClasses = classNames({
			'display': hasScheduleClosing
		}, 'inputs');

		return (
			<section className='close dates'>
				<input
					ref='closeLaterRadio'
					id='close_later_radio'
					type='checkbox'
					name='closeOptions'
					checked={hasScheduleClosing}
					onChange={this.toggleDate}
				></input>
				<label htmlFor='close_later_radio'>
					{localization.substitute('On a specific date')}
				</label>

				<div className={closeGroupClasses}>
					<div className='icon input'>
						<SVGIcon name='calendar' />
						{/* we use readOnly to avoid keystrokes */}
						<DatePicker
							ref='closeDateInput'
							selected={moment(schedule)}
							onChange={this.handleDateChange}
							showTimeSelect
							timeFormat="hh:mm A"
							timeIntervals={timeInterval}
							minDate={moment(minDate)}
							timeCaption="time"
							dateFormat="MM/DD/YYYY hh:mm A"
							readOnly={true}
						/>
					</div>
				</div>
			</section>
		);
	}

	handleDateChange = (date) => {
		const { addDateCallback } = this.props;
		const selectedDate = getUtcString(date);

		addDateCallback(FormSettings.CLOSE_SCHEDULE, selectedDate);
	};

	// Show/hide date section.
	toggleDate = (evt) => {
		const {
			addDateCallback,
			removeDateCallback
		} = this.props;

		if (evt.target.checked) {
			addDateCallback(FormSettings.CLOSE_SCHEDULE, this.props.schedule);
		} else {
			removeDateCallback(FormSettings.CLOSE_SCHEDULE);
		}
	};
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/sections/close-date.js